export enum ResponseStatus {
  Success = 200,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  InternalServerError = 500,
  BadGateway = 501,
  GatewayTimeout = 504,
}
